"use client";

import { useEffect, useState } from "react";

interface Props {
  referralCode?: string | null;
}
export const SignUpReferralAlert = ({ referralCode }: Props) => {
  const [refCode, setRefCode] = useState<string | null>(null);

  useEffect(() => {
    if (referralCode) {
      const storedReferralCode = localStorage.getItem("raffaello-referral-code");
      if (!storedReferralCode) {
        localStorage.setItem("raffaello-referral-code", referralCode);
      } // Save for when user signs up}
      // document.cookie = `raffaello-referral-code=${referralCode}; path=/`;
      console.log(`🎉🎉 referralCode: ${referralCode}`);
      setRefCode(referralCode);
    }
  }, [referralCode]);
  return (
    refCode && (
      <div>
        <p className="text-lg">🎉 You're signing up with a referral code! 🎉</p>
        <pre className="text-center font-bold text-xl">{referralCode}</pre>
      </div>
    )
  );
};
